module.exports = __webpack_public_path__ + "files/microsoft_certified_professional_certificate.e9732a39.pdf";